<template>
	<v-row
		class="align-conten"
		justify="center"
	>
		<v-col
			class="xs"
			sm="8"
			md="8"
			lg="8"
		>
			<v-row>
				<v-col>
					<message-box
						v-if="error"
						:message="error"
					/>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-card class="elevation-12">
						<v-toolbar
							dark
							color="primary"
						>
							<v-toolbar-title>התחברות</v-toolbar-title>
							<v-spacer />
						</v-toolbar>
						<v-form
							ref="form"
							@submit.prevent="onSubmit"
						>
							<v-card-text>
								<smart-input
									v-model="form.email"
									:required="true"
									prepend-icon="mdi-account"
									name="login"
									label="דואר אלקטרוני"
									type="email"
								/>
								<smart-input
									id="password"
									v-model="form.password"
									required
									prepend-icon="mdi-lock"
									name="password"
									label="סיסמה"
									type="password"
								/>
							</v-card-text>
							<v-card-actions class="d-flex flex-column">
								<v-spacer />
								<v-btn
									type="submit"
									color="#a82c9c"
									style="color:white;"
								>
									התחברות
								</v-btn>
							</v-card-actions>
							<v-card-actions
								class="d-flex flex-column"
								style="cursor: pointer;"
							/>
						</v-form>
					</v-card>
				</v-col>
			</v-row>
		</v-col>
	</v-row>
</template>

<script>
import { types } from "src/store/modules/Auth.module";

export default {
	props: {
		admin: { type: Boolean },
	},
	data: () => ({
		disabled: false,
		form: {
			email: null,
			password: null,
		},
		error: null,
	}),
	computed: {},
	methods: {
		googleLogin () {

		},
		async onSubmit () {
			this.disabled = true;
			this.$store.dispatch(types.LOGIN, this.form).then(
				async () => {
					this.disabled = false;
					this.$router.push({ name: "projects-view" });
				}, (error) => {
					this.disabled = false;
					this.error = error.response.data.errors.email[0];
				},
			);
		},
	},
};
</script>
